import { useMemo } from 'react';

import { isSavingAccount } from '@shared/products-core';
import type { Account } from '@shared/products-types';

import { useProducts } from './useProducts';

type HookReturnType = ReturnType<typeof useProducts<Account>>;

export const useSavingAccounts: () => HookReturnType = () => {
    const { isPending, error, refetch, products = [] } = useProducts();

    const [savingAccounts, savingAccountsById] = useMemo(() => {
        const filteredSavingAccounts = products.filter(isSavingAccount);
        return [
            filteredSavingAccounts,
            filteredSavingAccounts.reduce(
                (acc, current) => {
                    acc[current.id] = current;
                    return acc;
                },
                {} as HookReturnType['productsById'],
            ),
        ];
    }, [products]);

    return {
        isPending,
        error,
        refetch,
        products: savingAccounts,
        productsById: savingAccountsById,
    };
};
